module.exports = __webpack_public_path__ + "img/QR_boss.010113da.png";